
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { inject } from "inversify-props";
import { MealCountDtoViewModel } from "@/view-models";
import { MealCountDto, MergedLines, MergeLines } from "@/models";
import { ValidationErrors } from "fluentvalidation-ts/dist/ValidationErrors";
import { types } from "@/store";
import { eventBus, mcEvents, mcDate } from '@/utils';
import { routePaths } from '@/router';
import { IRouterService } from '@/services';

@Component
export default class McTakenOverPrompt extends Vue {
  @inject() private routerService!: IRouterService;

  @Prop() private model!: MealCountDtoViewModel;
  fluent: ValidationErrors<MealCountDto> = {};
  tempServingLineTrackingId: string | undefined;

  mounted() {
      eventBus.$on(mcEvents.mergedLines, this.checkForPrompt);
  }

  beforeDestroy() {
    eventBus.$off(mcEvents.mergedLines, this.checkForPrompt);
  }

  async checkForPrompt(mergedLines: MergedLines) {
    const foundId = mergedLines.servingLineTrackingIds.find(m => m === this.model.userServingLine?.trackingId);
    if (foundId) {
      this.$bvModal.show("takenOverPrompt");
    }
    else {
      const key = this.routerService.getMealCountKey();
      eventBus.$emit(mcEvents.receiveUpdatedCount, key);
    }
  }

  get currentUser() {
    return this.$store.getters[types.state.user];
  }

  get mergedServingLine() {
    let lineMerged = this.model.mealCounts.servingLines.find(u => u.mergedIntoTrackingId !== undefined && u.servedBy == this.currentUser.userId);
    return this.model.mealCounts.servingLines.find(u => u.trackingId == lineMerged?.mergedIntoTrackingId);
  }

  @Watch("model", {deep: true})
  userDateTime() {
    let merger = this.mergedServingLine;
    let mergedDateTime = this.model.mealCounts.servingLines.find(u => u.mergedIntoTrackingId == undefined && u.servedBy == this.currentUser.userId)?.createdDateTimeUtc;
    if (merger !== undefined) {
      let fullName =
        merger.servedByFirstName + " " + merger.servedByLastName;
      const local = mcDate.utcToLocal(mergedDateTime);
      const localTime = mcDate.toDateTime(local);

      return  `${fullName} @ ${localTime}`;
    }
  }

  hideModal() {
    this.$bvModal.hide("takenOverPrompt");
  }

  returnToDashboard() {
    eventBus.$emit(mcEvents.kickedFromServingLine);
    this.$router.push(routePaths.dashboard.path);
  }
}
